import { Field, useField } from 'formik';
import React from 'react';
import { Col, Row } from 'react-bootstrap';

/**
 * @param {{name, label, options, ...}} props
 * options => [{label: "label 1", value: 1}, {label: "label 2", value: 2}, ...]
 * where label is displayed, and value is an optional value attached for the item.
 * option to pass "allCheckedFieldKey: true" to an option to have it select or deselect all
 * checkboxes in the group
 */
const CheckBoxGroup = (props) => {
  const { label, name, negativeFillClass, options, size } = props;
  const [field, meta, helpers] = useField(name);

  const allCheckedFieldKey = options.find((el) => el.allChecked)?.value;

  const handleOnChange = (checkboxKey) => {
    let newValue;
    if (checkboxKey === allCheckedFieldKey) {
      newValue = field.value.includes(allCheckedFieldKey)
        ? [] // remove all values if "all" already checked
        : options.map((option) => option.value); // add all values if not
    } else {
      newValue = field.value.includes(checkboxKey)
        ? field.value.filter((key) => key !== checkboxKey) // remove value if exists
        : [...field.value, checkboxKey]; // add value if not
    }
    helpers.setValue(newValue);
  };

  const checkIfDisabled = (key) =>
    field.value.includes(allCheckedFieldKey) && key !== allCheckedFieldKey;

  return (
    <div className="CheckBoxGroup form-group">
      {label && (
        <label className="input-label" htmlFor={name} id="check-box-label">
          {label}
        </label>
      )}
      {options.map((el) => {
        return (
          <Row
            key={el.value}
            className={`checkbox-group-option ${meta.touched && meta.error ? 'is-invalid' : ''}`}
          >
            <Col xs={12}>
              <label
                className={`checkbox-container${checkIfDisabled(el.value) ? ' disabled' : ''}${
                  size === 'large' ? ' --large' : ''
                }`}
              >
                <Field
                  type="checkbox"
                  className="checkbox-input"
                  name={name}
                  id={el.value}
                  value={el.value}
                  checked={field.value.includes(el.value)}
                  onChange={() => handleOnChange(el.value)}
                />
                <span className={`checkbox-fill ${negativeFillClass ? 'fill-minus' : ''}`}></span>
                <span className="checkbox-text">{el.label}</span>
              </label>
            </Col>
          </Row>
        );
      })}
      {meta.touched && meta.error && <div className="invalid-feedback">{meta.error}</div>}
    </div>
  );
};

export default CheckBoxGroup;
